import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { FlatTypes } from '../../components/search_filters/building_types';
import {
  BuildingTypeFilterInput,
} from '../../components/search_filters/filters/building_type_filter';
import {
  NewbuildingBuildingTypeFilter as NewbuildingBuildingTypeFilterInput,
} from '../../components/search_filters/filters/newbuilding_filter_ab/newbuilding_building_type_filter';
import { IBuildingTypes } from '../../models/filters/building_types';
import { ISearchType } from '../../models/filters/type';
import { IMainPage } from '../../models/mainpage';
import { setBuildingType, setDirty } from '../../redux/modules/search/building_types';
import { AbstractFlatSearchConfig } from '../search_block/search_config';
import { GenericFilter } from './generic_filter';

import {
  AB_ALLOWED_SEARCH_TYPES_CHECKBOXES,
  AB_ALLOWED_SECTIONS_CHECKBOXES,
  getABNewbuildingSearchTabs,
} from '../../helpers/ab_newbuilding_search_tabs';

interface IProps {
  type: ISearchType;
  buildingType: IBuildingTypes;
  dispatch: Dispatch<any>;
  abNewbuildingSearchTabs: boolean;
}

interface IState {
  isDirty: boolean;
}

class FlatTypeFilter extends GenericFilter<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = { isDirty: false };
  }

  protected setDirty(isDirty: boolean) {
    this.props.dispatch(setDirty(isDirty));
  }

  public render() {
    const { abNewbuildingSearchTabs, type: {searchType, section = ''} } = this.props;
    const customButtonText = this.state.isDirty
      ? ''
      : 'В категории';

    if (
      abNewbuildingSearchTabs &&
      AB_ALLOWED_SEARCH_TYPES_CHECKBOXES.includes(searchType) &&
      AB_ALLOWED_SECTIONS_CHECKBOXES.includes(section)
    ) {
      return (
        <NewbuildingBuildingTypeFilterInput
          type={this.props.type.searchType}
          value={this.props.buildingType.buildingType[0]}
          buildingTypes={FlatTypes}
          searchConfig={AbstractFlatSearchConfig}
          customButtonText={customButtonText}
          onChange={this.onChange}
        />
      );
    }

    return (
      <BuildingTypeFilterInput
        isShortMode
        type={this.props.type.searchType}
        value={this.props.buildingType.buildingType}
        buildingTypes={FlatTypes}
        searchConfig={AbstractFlatSearchConfig}
        customButtonText={customButtonText}
        onChange={this.onChange}
      />
    );
  }

  private onChange = (type: string) => {
    this.props.dispatch(setBuildingType(type));
    this.setState({ isDirty: true });
  }
}

const FlatTypeFilterWrapper = connect((state: {
  buildingType: IBuildingTypes,
  type: ISearchType,
  mainpage: IMainPage,
}) => {
  return {
    buildingType: state.buildingType,
    type: state.type,
    abNewbuildingSearchTabs: getABNewbuildingSearchTabs(state.mainpage),
  };
})(FlatTypeFilter);

export { FlatTypeFilterWrapper as FlatTypeFilter, FlatTypeFilter as FlatTypeFilterClass };
